export const events = {
  goToGoal: 'Go to goal',
  createGoal: 'Create goal',
  viewGoal: 'View goal',
}
